import BaseApi from './base.api'

class WebSiteApi extends BaseApi {
  clipboardTypesUrl = 'clipboard-types/'
  citiesUrl = 'cities/'
  countriesUrl = 'countries/'
  creditsUrl = 'credits/'
  emailsUrl = 'emails/'
  currenciesUrl = 'currencies/'
  gridLayoutConfigurationsUrl = 'grid-layout-configurations/'
  documentRowTypesUrl = 'document-row-types/'
  importRowsUrl = 'import-rows/'
  notificationsUrl = 'notifications/'
  notificationsMarkAsReadUrl = 'notifications/mark-as-read/'
  paymentTypesUrl = 'payment-types/'
  paymentEffectTypesUrl = 'payment-effect-types/'
  printSettingsUrl = 'print-settings/'
  statesUrl = 'states/'
  unitConversionsUrl = 'unit-conversions/'
  unitsOfMeasureUrl = 'units-of-measure/'
  userDetailsUrl = 'user-details/'
  urgencyTypesUrl = 'urgency-types/'
  usersUrl = 'users/'
  fetchNotificationDetailsAsync = 'users/'
  vatTypesUrl = 'vat-types/'

  constructor() {
    super('web-site/')
  }

  downloadNotificationAsync = (id, filename) => this.download(`${this.notificationsUrl}${id}/download/`, filename)

  getTokenAsync = (username, password) => this.post('token', { username, password }, { credentials: 'include', skipAuthorization: true })
  getTokenOidcAsync = (code) => this.httpApi.post(`${window.config.AUTH_SERVER_URL}${window.config.AUTH_TOKEN_PATH}/`, {
    grant_type: 'authorization_code',
    code: code,
    client_id: window.config.AUTH_CLIENT_ID,
    client_secret: '',
    redirect_uri: window.config.AUTH_REDIRECT_URI,
    token_type: 'JWT',
  }, {
    headers: {
      'Cache-Control': 'no-cache',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    withCredentials: false,
    skipAuthorization: true,
  })

  getFreshTokenAsync = (refreshToken) => this.post('token/refresh', {refresh: refreshToken}, { credentials: 'include', skipAuthorization: true })
  getFreshTokenOidcAsync = (refreshToken) => this.httpApi.post(`${window.config.AUTH_SERVER_URL}${window.config.AUTH_TOKEN_PATH}/`, {
    grant_type: 'refresh_token',
    refresh_token: refreshToken,
    client_id: window.config.AUTH_CLIENT_ID,
    client_secret: '',
    token_type: 'JWT',
  }, {
    headers: {
      'Cache-Control': 'no-cache',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    withCredentials: false,
    skipAuthorization: true,
  })

  // getUserDetailsAsync = (userId) => this.get(`${this.usersUrl}${userId}/details`)

  getLastUpdateAsync = () => this.get('last-update')

  getClaims = () => this.httpApi.get(`${window.config.AUTH_SERVER_URL}${window.config.AUTH_CLAIMS_PATH}`)
  getCitiesAsync = (params) => this.get(this.citiesUrl, params)
  getClipboardTypesAsync = (params) => this.get(this.clipboardTypesUrl, params)
  getCountriesAsync = (params) => this.get(this.countriesUrl, params)
  getCurrenciesAsync = (params) => this.get(this.currenciesUrl, params)
  getDocumentRowTypesAsync = (params) => this.get(this.documentRowTypesUrl, params)
  getNotificationsAsync = (params) => this.get(this.notificationsUrl, params)
  getNotificationDetailsByIdAsync = (id) => this.get(`${this.notificationsUrl}${id}/details`)
  getPaymentTypesAsync = (params) => this.get(this.paymentTypesUrl, params)
  getPaymentEffectTypesAsync = (params) => this.get(this.paymentEffectTypesUrl, params)
  getPrintSettingsAsync = (params) => this.get(this.printSettingsUrl, params)
  getProductFamiliesAsync = (params) => this.get(this.productFamiliesUrl, params)
  getStatesAsync = (params) => this.get(this.statesUrl, params)
  getUnitConversionsAsync = (params) => this.get(this.unitConversionsUrl, params)
  getUnitsOfMeasureAsync = (params) => this.get(this.unitsOfMeasureUrl, params)
  getUrgencyTypesAsync = (params) => this.get(this.urgencyTypesUrl, params)
  getUserDetailsAsync = (params) => this.get(this.userDetailsUrl, params)
  getMechanicsActivitiesAsync = (params) => this.get(`${this.userDetailsUrl}mechanics-activities/`, params)
  updateImportGridPreferenceAsync = (data) => this.patch(`${this.userDetailsUrl}import-grid-preference/`, data)
  getVatTypesAsync = (params) => this.get(this.vatTypesUrl, params)
  getCreditsAsync = (params) => this.get(this.creditsUrl, params)

  importClipboardRowsAsync = (data) => this.post(`${this.importRowsUrl}import-rows/`, data)

  printReport = (data) => this.download(`${this.printSettingsUrl}print/`, null, null, false, { method: 'post', data: data })

  addPrintSettingsAsync = (data) => this.post(this.printSettingsUrl, data)
  updatePrintSettingsAsync = (id, data) => this.patch(`${this.printSettingsUrl}${id}/`, data)
  updateNotificationsAsReadAsync = (data, params) => this.post(this.notificationsMarkAsReadUrl, data, params)

  restoreDeletedUserDetail = (id) => this.patch(`${this.userDetailsUrl}${id}`, { deleted_at: null })

  sendEmailAsync = (data) => this.post(`${this.emailsUrl}send`, data)

  createGridLayoutConfigurationAsync = (data) => this.post(this.gridLayoutConfigurationsUrl, data)
  deleteGridLayoutConfigurationAsync = (id) => this.delete(`${this.gridLayoutConfigurationsUrl}${id}/`)
  getGridLayoutConfigurationsAsync = (params) => this.get(this.gridLayoutConfigurationsUrl, params)
  deactivateGridLayoutConfigurationsAsync = (data) => this.post(`${this.gridLayoutConfigurationsUrl}deactivate/`, data)
  updateGridLayoutConfigurationAsync = (id, data) => this.patch(`${this.gridLayoutConfigurationsUrl}${id}/`, data)
}

export const webSiteApi = new WebSiteApi('web-site')
